import { Divider, Flex } from '@chakra-ui/react';
import React, { useState } from 'react';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  AppHeader,
  HeaderRow,
  GlobalNav,
  GlobalNavRouterLinkItem,
  LayoutWithSidebar,
  LayoutContextProvider,
} from '~/packages/common-frontend/layout';

// Constants
const COMPONENT_NAME = './common-frontend/layout/Layout';

// Helpers
const filler = Array(50)
  .fill(1)
  .map((_, index) => index)
  .map((value) => <p key={value}>{value}</p>);

// Fragments
const RouteBase = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [subHeaderVisible, setSubHeaderVisible] = useState(false);
  const [pageHeaderVisible, setPageHeaderVisible] = useState(false);
  return (
    <LayoutWithSidebar
      globalNav={
        <GlobalNav>
          <GlobalNavRouterLinkItem
            to="/dev"
            label="Home"
            icon={<Icon icon="house" />}
          />
          <GlobalNavRouterLinkItem
            to="."
            label="Tasks (74)"
            icon={<Icon icon="list-ul" />}
          />
          <GlobalNavRouterLinkItem
            to="."
            label="Insights"
            expandedStoreKey="DevNavBar.Insights"
            icon={<Icon icon="chart-pie-simple" />}
          >
            <GlobalNavRouterLinkItem to="." label="Portfolio" size="sm" />
            <GlobalNavRouterLinkItem to="." label="Strats" size="sm" />
            <GlobalNavRouterLinkItem to="." label="CDQ Monitoring" size="sm" />
            <GlobalNavRouterLinkItem to="." label="Covenants" size="sm" />
          </GlobalNavRouterLinkItem>
          <GlobalNavRouterLinkItem
            to="."
            label="Facilities"
            icon={<Icon icon="building-columns" />}
          />
          <GlobalNavRouterLinkItem
            to="."
            label="Funding"
            expandedStoreKey="DevNavBar.Funding"
            icon={<Icon icon="dollar-sign" />}
          >
            <GlobalNavRouterLinkItem to="." label="Requests" size="sm" />
            <GlobalNavRouterLinkItem to="." label="Loans" size="sm" />
            <GlobalNavRouterLinkItem to="." label="Invoices" size="sm" />
            <GlobalNavRouterLinkItem to="." label="Lender Shares" size="sm" />
          </GlobalNavRouterLinkItem>
          <GlobalNavRouterLinkItem
            to="."
            label="Transactions"
            icon={<Icon icon="money-check-dollar" />}
          />
          <GlobalNavRouterLinkItem
            to="."
            label="Deliverables"
            icon={<Icon icon="calendar" />}
          />
          <Divider margin="0.5rem 0" width="auto" />
          <GlobalNavRouterLinkItem
            to="."
            label="Settings"
            icon={<Icon icon="gear" />}
            size="sm"
          />
        </GlobalNav>
      }
      header={
        <AppHeader
          isAdmin={isAdmin}
          HeaderRowProps={{ FlexProps: { position: 'relative' } }}
        />
      }
      subHeader={
        subHeaderVisible && (
          <HeaderRow FlexProps={{ position: 'relative' }}>
            Sub header (used on Valley routes)
          </HeaderRow>
        )
      }
      pageHeader={
        pageHeaderVisible && (
          <HeaderRow FlexProps={{ position: 'relative' }}>
            Page header (used on Facility settings routes)
          </HeaderRow>
        )
      }
    >
      <PageTemplate title={COMPONENT_NAME}>
        <Flex direction="column" gap="1rem">
          <Flex gap="1rem" alignItems="center">
            <IconButtonV2
              placement="bottom"
              isActive={subHeaderVisible}
              aria-label="Toggle subheader"
              icon={<Icon icon="bars" />}
              variant="primary-muted"
              colorScheme="v2-aurora"
              onClick={() => setSubHeaderVisible((prev) => !prev)}
            />{' '}
            Toggle subheader (only used on ValleyBank)
          </Flex>
          <Flex gap="1rem" alignItems="center">
            <IconButtonV2
              placement="bottom"
              isActive={pageHeaderVisible}
              aria-label="Toggle pageheader"
              icon={<Icon icon="square-list" />}
              variant="primary-muted"
              colorScheme="v2-aurora"
              onClick={() => setPageHeaderVisible((prev) => !prev)}
            />{' '}
            Toggle pageheader (only used on facility settings pages)
          </Flex>
          <Flex gap="1rem" alignItems="center">
            <IconButtonV2
              placement="bottom"
              isActive={isAdmin}
              aria-label="Toggle isAdmin"
              icon={<Icon icon="hammer" />}
              variant="primary-muted"
              colorScheme="v2-aurora"
              onClick={() => setIsAdmin((prev) => !prev)}
            />{' '}
            Toggle <code>isAdmin</code>
          </Flex>
        </Flex>

        <Flex direction="column">{filler}</Flex>
      </PageTemplate>
    </LayoutWithSidebar>
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <LayoutContextProvider>
      <RouteBase />
    </LayoutContextProvider>
  </RouteErrorBoundary>
);
